// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._zulppxbi{gap:var(--ds-space-200,1pc)}
._zulpu2gc{gap:var(--ds-space-100,8px)}._16jlkb7n{flex-grow:1}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._4cvr1h6o{align-items:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/link-datasource/dist/esm/ui/assets-modal/search-container/styled.compiled.css"],"names":[],"mappings":";AACA,WAAW,2BAA2B;AACtC,WAAW,2BAA2B,CAAC,WAAW,WAAW;AAC7D,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,kBAAkB","sourcesContent":["\n._zulppxbi{gap:var(--ds-space-200,1pc)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}._16jlkb7n{flex-grow:1}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
